/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEventHandler} from 'react';
import {Moment} from 'moment';
import {translate} from '@ion/core/src/locale/locale';
import {FloatingIconButtonGroup} from '@ion/dls/src/components/buttons/FloatingIconButton';
import Tooltip from '@ion/dls/src/components/tooltip/Tooltip';
import {useIsPhone} from '@ion/dls/src/hooks/useMedia';
import {PlayIcon} from '@ion/dls/src/icons/PlayIcon';
import {IconSize} from '@ion/dls/src/types/types';

// defines the prop definitions for the TimeSliderProps Tool
export type TimeSliderProps = {
  onToggleTimeSlider: MouseEventHandler<HTMLButtonElement>;
  timeSliderDisabled: boolean;
};

export interface Timeline {
  start: Moment | null,
  end: Moment | null,
  isTimeSliderOn: boolean
};

export const TimeSliderTool = ({
  onToggleTimeSlider,
  timeSliderDisabled
}: TimeSliderProps) => {
  const isPhone = useIsPhone();
  return (
    <FloatingIconButtonGroup isVertical>
      <>
        <Tooltip title={timeSliderDisabled
          ?translate('maps:controls.timeSliderDisabled') : translate('maps:controls.timeSlider')} renderOnlyChildren={isPhone}>
          <div>
            <FloatingIconButtonGroup.FloatingIconButton onClick={onToggleTimeSlider}
              disabled={timeSliderDisabled}>
              <PlayIcon size={IconSize.medium}/>
            </FloatingIconButtonGroup.FloatingIconButton>
          </div>
        </Tooltip>
      </>
    </FloatingIconButtonGroup>
  );
};

export default TimeSliderTool;
